import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { CountPayload, DatasetModel, QuestionPayload } from '../../models/dataset.model';
import { DATASET_INITIAL_ID } from '../../../common/constants';

// identifier
export const DATASET_SLICE_ID = 'dataset';

// default state
const initialState: DatasetModel = {};

//slice
const datasetSlice = createSlice({
  name: DATASET_SLICE_ID,
  initialState,
  reducers: {
    setDatasetQuestion: (state: DatasetModel, action: PayloadAction<QuestionPayload>): void => {
      const { datasetId = DATASET_INITIAL_ID, question, projectId } = action.payload;

      const key = `${projectId}-${datasetId}`;

      if (!state[key]) {
        state[key] = { question: null, totalCount: 0 };
      }
      state[key].question = question;
    },
    setTotalCount: (state: DatasetModel, action: PayloadAction<CountPayload>): void => {
      const { datasetId = DATASET_INITIAL_ID, totalCount, projectId } = action.payload;

      const key = `${projectId}-${datasetId}`;

      if (!state[key]) {
        state[key] = { question: null, totalCount: 0 };
      }
      state[key].totalCount = totalCount;
    },
    resetDatasetQuestion: (state: DatasetModel): void => {
      Object.keys(state).forEach((key) => delete state[key]);
      Object.assign(state, initialState);
    },
  },
});

//selectors
export const selectDatasetQuestion = (
  state: RootState,
  datasetQuestionId: string = DATASET_INITIAL_ID,
  projectId: string
) => {
  const key = `${projectId}-${datasetQuestionId}`;

  if (state.dataset[key]) {
    return state.dataset[key].question;
  }
  return null;
};

export const selectQuestionCount = (
  state: RootState,
  datasetQuestionId: string = DATASET_INITIAL_ID,
  projectId: string
) => {
  const key = `${projectId}-${datasetQuestionId}`;

  if (state.dataset[key]) {
    return state.dataset[key].totalCount;
  }
  return 0;
};

//actions
export const { setDatasetQuestion, setTotalCount, resetDatasetQuestion } = datasetSlice.actions;

//reducer
export default datasetSlice;
